import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { initServiceWorkerRegistration } from "@/pwa/sw-registration";
import { cleanupRetiredRuntimeCaches } from "@/utilities/pwa-utils";
import App from "./App.tsx";
import "./styles/index.css";

// Drop caches left by an earlier service worker before it can answer any
// request. A stale `api-cache` entry would otherwise keep serving a failed
// response until it expired. Deliberately not awaited: cache maintenance
// must never delay first paint, and the deletes complete well before the
// app's first authenticated request.
void cleanupRetiredRuntimeCaches();
initServiceWorkerRegistration();

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <App />
  </StrictMode>
);
